<template>
  <highcharts :key="hcKey" :options="chartOptions" ref="returnRiskCost"></highcharts>
</template>
<script>
import { setChartMenuItemsLang } from '../../../utils/formatter'
export default {
  name: 'ReturnRiskCost',
  props: {
    value: {},
    indicatorsValue: {},
    title: {},
    whenMopVisualize: {},
  },
  data() {
    return {
      hcKey: 0,
    }
  },
  computed: {
    chartOptions: function () {
      var vueThis = this
      return {
        lang: this.setOptions,
        chart: {
          type: 'bubble',
          zoomType: 'xy',
          backgroundColor: '#FFFFFF',
          height: '50%',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: this.title,
          style: { fontSize: '25px', fontWeight: 'bold' },
        },
        plotOptions: {
          bubble: {
            minSize: 5,
            maxSize: 30,
          },
        },
        legend: {
          enabled: true,
          align: 'left',
          layout: 'vertical',
          verticalAlign: 'top',
          itemMarginTop: 10,
          bubbleLegend: {
            enabled: false,
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            // TODO: CHECK IF PERCANTAGE OR DECIMAL
            const numberType = ['MRM', 'SRI'].includes(vueThis.indicatorsValue.z) ? '' : 'percent'
            return (
              '<b class="hc-tooltip-title">' +
              this.point.meta.name +
              '</b><br>' +
              '<b>' +
              this.point.meta.issuerName +
              '</b><br>' +
              '<b>' +
              vueThis.$n(this.point.z, numberType) +
              '</b><br>'
            )
          },
        },
        xAxis: {
          gridLineWidth: 2,
          labels: {
            formatter: ['MRM', 'SRI'].includes(this.indicatorsValue.x)
              ? (el) => el.value
              : (el) => this.$n(el.value, 'percent'),
          },
          allowDecimals: !['MRM', 'SRI'].includes(this.indicatorsValue.x),
          title: {
            text: this.getMarketComparationIndicesForReturnRiskCost.x.find((el) => el.value === this.indicatorsValue.x)
              .text,
          },
        },
        yAxis: {
          title: {
            text: this.getMarketComparationIndicesForReturnRiskCost.y.find((el) => el.value === this.indicatorsValue.y)
              .text,
          },
          labels: {
            formatter: this.getMarketComparationKeys('y').includes(this.indicatorsValue.y)
              ? (el) => this.$n(el.value, 'percent')
              : (el) => el.value,
          },
        },
        series: Object.keys(this.dataSeries)
          .sort()
          .map((key) => {
            return {
              name: key,
              data: this.dataSeries[key].map((el) => {
                return {
                  x: el.x,
                  y: el.y,
                  z: el.z,
                  meta: {
                    name: el.productKey.name,
                    issuerName: el.productKey.issuerName,
                    y: el.y,
                    x: el.x,
                    z: el.z,
                  },
                }
              }),
            }
          }),
      }
    },
    dataSeries: function () {
      const data = this.value
      if (data.length === 0) {
        return {}
      }

      let arrX = []
      let arrZ = []
      let arrY = []

      data.forEach((el) => {
        if (this.indicatorsValue.x === el.indicatorCode) {
          arrX = el.chartItems.map((item) => {
            return { productKey: item.productKey, x: item[this.whenMopVisualize] }
          })
        }
        if (this.indicatorsValue.z === el.indicatorCode) {
          arrZ = el.chartItems.map((item) => {
            return { productKey: item.productKey, z: item[this.whenMopVisualize] }
          })
        }
        if (this.getMarketComparationKeys('y').includes(el.indicatorCode)) {
          arrY = el.chartItems.map((item) => {
            return { productKey: item.productKey, y: item[this.whenMopVisualize] }
          })
        }
      })

      if (arrX.length === 0 || arrZ.length === 0 || arrY.length === 0) {
        return {}
      }

      let list = arrX.concat(arrZ, arrY)

      let chartItems = list.reduce((accumulator, reducer) => {
        let unique_key = reducer.productKey.issuerCode + '_' + reducer.productKey.name
        accumulator[unique_key] = accumulator[unique_key] || []
        accumulator[unique_key].push(reducer)
        return accumulator
      }, Object.create(null))

      if (chartItems.length === 0) {
        return {}
      }

      Object.keys(chartItems).forEach((el) => {
        if (!(chartItems[el].length === 3)) {
          delete chartItems[el]
        }

        if (chartItems[el]) {
          const productKey = { ...chartItems[el][0].productKey }
          const xVal = chartItems[el].find((el) => 'x' in el).x
          const zVal = chartItems[el].find((el) => 'z' in el).z
          const yVal = chartItems[el].find((el) => 'y' in el).y

          chartItems[el] = {
            productKey: productKey,
            x: xVal,
            z: zVal,
            y: yVal,
          }
        }
      })

      if (Object.values(chartItems).length === 0) {
        return {}
      }

      return Object.values(chartItems).reduce((accumulator, reducer) => {
        accumulator[reducer.productKey.issuerName] = accumulator[reducer.productKey.issuerName] || []
        accumulator[reducer.productKey.issuerName].push(reducer)
        return accumulator
      }, Object.create(null))
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
  methods: {
    getMarketComparationKeys(property) {
      return this.getMarketComparationIndicesForReturnRiskCost[property].map((el) => el.value)
    },
  },
}
</script>
<style lang="scss" scoped></style>
